import { VUE_APP_HYPERSIGN_SERVICE_BASE_URL_FORMAT } from '../../config'
import SignStoreConfig from './config'
import { parseJson } from '../../components/utils/storage'
export default {
  enabledSteps: (state) => state.steps.filter((step) => step.isEnabled),
  currentStep: (state, getters) => getters.enabledSteps[state.currentStepIndex],
  enabledStepsToShow: (state, getters) => getters.enabledSteps.filter((x) => x.name != null),
  isFirstStep: (state) => state.currentStepIndex === 0,
  isLastStep: (state, getters) => state.currentStepIndex === getters.enabledSteps.length - 1,
  totalConfiguredSteps: (state, getters) => getters.enabledSteps.length,
  currentStepNumber: (state) => state.currentStepIndex + 1, // 1-based index for display
  getSession() {
    const session = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SESSIONS)
    if (!session || session === 'undefined' || session === 'null') {
      return null
    }
    return session
  },
  isSessionValid() {
    const session = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SESSIONS)
    if (!session || session === 'undefined' || session === 'null') return false

    const mobileFlowSession = localStorage.getItem(SignStoreConfig.LOCAL_STATES.MOBILE_FLOW_SESSION)
    if (mobileFlowSession === session) return true

    const expiresAt = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SESSION_EXPIRES_AT)
    if (!expiresAt) return false
    return new Date(expiresAt) > new Date()
  },
  isMobileFlowSession() {
    const session = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SESSIONS)
    const mobileFlowSession = localStorage.getItem(SignStoreConfig.LOCAL_STATES.MOBILE_FLOW_SESSION)
    return Boolean(session && mobileFlowSession === session)
  },
  getMobileFlowStep() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.MOBILE_FLOW_STEP)
  },
  isKycTokenValid() {
    const token = localStorage.getItem(SignStoreConfig.LOCAL_STATES.KYC_SERVICE_USER_ACCESS_TOKEN)
    if (!token) return false
    try {
      const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))
      return payload.exp && payload.exp * 1000 > Date.now()
    } catch {
      return false
    }
  },
  getCavachAccessToken() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.KYC_ACCESS_TOKEN)
  },
  getRedirectUrl() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.REDIRECT_URL)
  },
  getProfile() {
    const profileStr = localStorage.getItem(SignStoreConfig.LOCAL_STATES.PROFILE)
    return parseJson(profileStr)
  },
  getSSIAccessToken() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.SSI_ACCESS_TOKEN)
  },
  getEnv(state) {
    // Return from state if available, otherwise fallback to localStorage
    return state.environment || localStorage.getItem(SignStoreConfig.LOCAL_STATES.ENVIRONMENT)
  },
  getTenantSubdomain() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.SUBDOMAIN)
  },

  getTenantKycServiceBaseUrl() {
    const subdomain = localStorage.getItem(SignStoreConfig.LOCAL_STATES.SUBDOMAIN)
    if (!subdomain) {
      throw new Error('Invalid accessToken')
    }
    return VUE_APP_HYPERSIGN_SERVICE_BASE_URL_FORMAT.replace('<subdomain>', ``)
  },

  getPublicKycServiceBaseUrl() {
    return VUE_APP_HYPERSIGN_SERVICE_BASE_URL_FORMAT.replace('<subdomain>', '')
  },

  getPresentationRequest() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.PR)
  },

  getPresentationRequestParsed() {
    const base64EncodedPr = localStorage.getItem(SignStoreConfig.LOCAL_STATES.PR)
    if (!base64EncodedPr) {
      return null
    }
    try {
      const prStr = atob(base64EncodedPr)
      return JSON.parse(prStr)
    } catch {
      return null
    }
  },

  getIdDocumentLicenseKey(state) {
    return state.idDocumentLicenseKey
  },

  getOnChainIssuerConfig: () => {
    const t = localStorage.getItem(SignStoreConfig.LOCAL_STATES.ON_CHAIN_CONFIG)
    if (t) {
      return parseJson(t)
    } else {
      return null
    }
  },
  getKycServiceUserAccessToken() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.KYC_SERVICE_USER_ACCESS_TOKEN)
  },
  getWidgetConfigFromDb: (state) => {
    // First try to get from state (reactive)
    if (state.widgetConfigFromDb) {
      return state.widgetConfigFromDb
    }
    // Fallback to localStorage for initialization
    const t = localStorage.getItem(SignStoreConfig.LOCAL_STATES.WIDGET_CONFIG)
    if (t) {
      const config = parseJson(t)
      if (!config) {
        return null
      }
      // Update state if localStorage has data but state doesn't
      state.widgetConfigFromDb = config
      return config
    }
    return null
  },
  getWidgetConfigId() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.WIDGET_CONFIG_ID)
  },
  getThirdPartyAuth(state) {
    return state.authenticationAccessToken
  },
  getUtmSource() {
    return localStorage.getItem(SignStoreConfig.LOCAL_STATES.UTM_SOURCE)
  },
  getMobileFlowError(state) {
    return state.mobileFlowError
  },
}
